<template>
    <Top />
    <!-- Spinner Start -->
    <div id="spinner" v-if="halamanloading"
        class="show bg-white position-fixed translate-middle w-100 vh-100 top-50 start-50 d-flex align-items-center justify-content-center">
        <div class="spinner-border text-danger" style="width: 3rem; height: 3rem;" role="status">
            <span class="sr-only">Loading...</span>
        </div>
        &nbsp;<img src="../../../../src/assets/img/BerandaNgumahLogo.png" height="40">
        &nbsp;<span class="text-danger">..Loading...</span>
    </div>
    <!-- Spinner End -->
    <!-- Header Start -->
    <div class="modal fade" id="costumModaldisclaimer" data-easein="flipBounceYIn" tabindex="-1" role="dialog"
        aria-labelledby="costumModalLabel" aria-hidden="true" data-backdrop="static" data-keyboard="false"
        style="background: rgba(240, 248, 255, 0.1);">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title">Penjelasan dan Ketentuan</h4>
                </div>
                <div class="modal-body text-justify">
                    <p style="font-size: smaller;">
                        <b>SIMFAST JATENG</b> (Sistem Manajemen Infrastruktur Terpadu Jawa Tengah)
                        yang selanjutnya dioptimalkan sebagai "<b>Strategi Mensinergikan Fokus dan Arah Kebijakan
                        Perencanaan Berbasis Data Spasial Terpadu di Jawa Tengah</b>" merupakan sistem manajemen (alat
                        kerja) yang mengintegrasikan analisa data dan informasi infrastruktur (terkait Urusan PUPR,
                        Perhubungan, Prakim, LHK, ESDM, Kominfo) secara terpadu dengan sektor lain (ekonomi dan sosial)
                        untuk menghasilkan prioritas rencana penanganan infrastruktur di Jawa Tengah yang paling efektif
                        dan efisien dalam mewujudkan tujuan pembangunan di Provinsi Jawa Tengah.
                    </p>
                    <p class="text-center">
                    <div class="row">
                        <div class="col-sm-12 float-left">
                            <label style="font-size: smaller;" class="text-success">Silahkan Mengisi Daftar
                                Pengunjung</label>
                        </div>
                        <div class="col-sm-12 float-left">
                            <div class="input-group mb-3">
                                <div class="input-group-prepend">
                                    <span class="input-group-text"><i class="far fa-address-card"></i></span>
                                </div>
                                <input type="text" class="form-control form-control-sm" id="nama" name="nama"
                                    placeholder="Nama" v-model="nama">
                            </div>
                        </div>
                        <div class="col-sm-12 float-left">
                            <div class="input-group mb-3">
                                <div class="input-group-prepend">
                                    <span class="input-group-text"><i class="fas fa-phone-square"></i></span>
                                </div>
                                <input type="text" class="form-control form-control-sm" id="hp" name="hp"
                                    placeholder="Nomor Telepon" v-model="hp" @keypress="onlyNumberKey(event)"
                                    @keydown="onlyNumberKey(event)">
                            </div>
                        </div>
                        <div class="col-sm-12 float-left">
                            <div class="input-group mb-3">
                                <div class="input-group-prepend">
                                    <span class="input-group-text"><i class="fas fa-clipboard-list"></i></span>
                                </div>
                                <input type="text" class="form-control form-control-sm" id="keperluan" name="keperluan"
                                    placeholder="Keperluan" v-model="keperluan">
                            </div>
                        </div>
                        <div class="col-sm-6 float-left">
                            <label style="font-size: smaller;" class="text-success">Kode Keamanan</label>
                            <div class="input-group mb-3">
                                <div class="input-group-prepend">
                                    <span class="input-group-text"><i class="fas fa-key"></i></span>
                                </div>
                                <input type="text" class="form-control form-control-sm" id="capcha" name="capcha"
                                    placeholder="Kode Keamanan" v-model="capcha" disabled @click.right.prevent
                                    @keydown="keydown" @copy.prevent @paste.prevent>
                            </div>
                        </div>
                        <div class="col-sm-6 float-left">
                            <label style="font-size: smaller;" class="text-success">Ulangi Kode Keamanan</label>
                            <div class="input-group mb-3">
                                <div class="input-group-prepend">
                                    <span class="input-group-text"><i class="far fa-clone"></i></span>
                                </div>
                                <input type="text" class="form-control form-control-sm" id="capchainput"
                                    name="capchainput" v-model="capchainput" style="text-transform:uppercase"
                                    @click.right.prevent @keydown="keydown" @copy.prevent @paste.prevent>
                            </div>
                        </div>
                    </div>
                    <input type="checkbox" id="customSwitchAuth" @click="rubahisi()">
                    <label style="font-size: small;" for="customSwitchAuth">
                        &nbsp;Saya mengerti dan menyetujui penjelasan dan ketentuan diatas.
                    </label>
                    </p>
                </div>
                <div class="modal-footer justify-content-between">
                    <button class="btn btn-danger2 btn-block text-white" placeholder="Setuju dan lanjutkan"
                        data-toggle="tooltip" data-placement="left" title="Setuju dan lanjutkan.." style="color: black;"
                        :disabled="showHuman == false" @click="setuju()">
                        <b>
                            Setuju dan lanjutkan
                        </b>
                    </button>
                </div>
            </div>
        </div>
    </div>
    <div class="modal fade" id="costumModaldisclaimerbukutamu" data-easein="flipBounceYIn" tabindex="-1" role="dialog"
        aria-labelledby="costumModalLabel" aria-hidden="true" data-backdrop="static" data-keyboard="false"
        style="background: rgba(240, 248, 255, 0.1);">
        <div class="modal-dialog modal-xl">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title">Daftar Isian Buku Tamu</h4>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body text-justify">
                    <div class="col-sm-12">
                        <div class="card cardputih">
                            <div class="card-header border-transparent">
                                <div class="card-tools">
                                    <button type="button" class="btn btn-tool" data-card-widget="collapse">
                                        <i class="fas fa-minus"></i>
                                    </button>
                                </div>
                                <div class="col-sm-12 float-left pb-2">&nbsp;</div>
                                <div class="col-sm-12 float-left pb-2 px-3">
                                    Jumlah Data {{ G_numFormat(jumlahdata) }}
                                    <span style="float: right;">
                                        <span>Halaman ke: </span>
                                        <select v-model="halaman" @change="onChangeHalaman($event)">
                                            <option v-for="index in jumlahhalaman" :key="index">
                                                {{ index }}</option>
                                        </select>
                                        <span> dari </span> {{ jumlahhalaman }}
                                    </span>
                                </div>
                                <div class="col-sm-12 float-left pb-2">

                                </div>
                            </div>
                            <div class="card-body p-2">
                                <div class="table-responsive table-wrapper">
                                    <table class="table m-0" id="tabeldata" style="font-size: small;">
                                        <thead>
                                            <tr>
                                                <th style="width: 50px;">No</th>
                                                <th style="width: 150px;">Nama</th>
                                                <th style="width: 100px;">Nomor Telp</th>
                                                <th style="width: 250px;">Keperluan</th>
                                                <th style="width: 150px;">IP Address</th>
                                                <th style="width: 150px;">Tanggal Akses</th>
                                            </tr>
                                        </thead>
                                        <template v-for="(datalist, urutlist) in datanya" :key="urutlist">
                                            <tbody>
                                                <tr>
                                                    <td class="text-center">
                                                        {{ (urutlist + 1) + (20 * halaman) - 20 }}
                                                    </td>
                                                    <td class="text-justify">
                                                        {{ (datalist.nama) }}
                                                    </td>
                                                    <td class="text-left">
                                                        {{ (datalist.hp) }}
                                                    </td>
                                                    <td class="text-justify">
                                                        {{ (datalist.keperluan) }}
                                                    </td>
                                                    <td class="text-justify">
                                                        {{ (datalist.ipaddressnya) }}
                                                    </td>
                                                    <td class="text-center">
                                                        {{ G_formatDate(datalist.createddate) }}
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </template>
                                        <tbody v-if="(datapesan == 'data kosong')">
                                            <tr>
                                                <label>Data masih kosong</label>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div class="card-footer p-3">

                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer justify-content-between">
                    <button class="btn btn-danger2 btn-block text-white" placeholder="Tutup" data-toggle="tooltip"
                        data-placement="left" title="Tutup.." style="color: black;" @click="tutupmodal()">
                        <b>
                            Tutup
                        </b>
                    </button>
                </div>
            </div>
        </div>
    </div>
    <div class="container-fluid bg-breadcrumb">
        <div class="container text-center py-5" style="max-width: 900px;">
            <h3 class="text-white display-3 mb-4 wow fadeInDown pmisputih" data-wow-delay="0.1s">
                <span v-if="(bahasa === null) || (bahasa == 'ina')">STATISTIK BUKU TAMU</span>
                <span v-else>STATISTIK BUKU TAMU</span>
            </h3>
            <ol class="breadcrumb justify-content-center mb-0 wow fadeInDown" data-wow-delay="0.3s">
                <li class="breadcrumb-item">
                    <a href="/">
                        <span v-if="(bahasa === null) || (bahasa == 'ina')">Beranda</span>
                        <span v-else>Home</span>
                    </a>
                </li>
                <li class="breadcrumb-item active text-primary">
                    <span v-if="(bahasa === null) || (bahasa == 'ina')">Statistik Simfast Jateng</span>
                    <span v-else>Statistik Simfast Jateng</span>
                </li>
            </ol>
        </div>
    </div>
    <!-- Header End -->
    <!-- Contact Start -->
    <div class="container-fluid blog py-2">&nbsp;</div>
    <div class="container-fluid bg-breadcrumbberanda wow fadeInDown">
        <div class="section-title mb-2 wow fadeInDown" data-wow-delay="0.1s">
            <div class="col-lg-12 col-xl-12 wow fadeInRight" data-wow-delay="0.3s">
                <div class="col-lg-12 col-xl-12 wow fadeInRight" data-wow-delay="0.3s">
                    <img src="../../../../src/assets/img/logojateng.png" height="100"><br>
                    <h1 class="text-danger m-0 pmisdanger" style="font-size: x-large;">PEMERINTAH PROVINSI JAWA TENGAH
                    </h1>
                    <span v-if="(bahasa === null) || (bahasa == 'ina')"> Badan Perencanaan Pembangunan Daerah Provinsi
                        Jawa Tengah<br>
                    </span>
                    <span v-if="(bahasa === null) || (bahasa == 'ina')"> Jl. Pemuda No.127-133, Kota Semarang, Jawa
                        Tengah 50132<br>
                    </span>
                    <span v-if="(bahasa === null) || (bahasa == 'ina')"> Telp. (024) 351 5591 Email :
                        bappeda@jatengprov.go.id<br>
                    </span><br>
                </div>
                <div class="col-lg-12 col-xl-12 wow fadeInRight" data-wow-delay="0.3s">&nbsp;</div>
            </div>
        </div>
    </div>
    <div class="container-fluid bg-breadcrumbberanda wow fadeInDown">
        <div class="section-title mb-2">
            <div class="row">
                <div class="col-sm-12 wow fadeInLeft">
                    <img src="../../../../src/assets/img/visit.png" height="140">
                    <h1 class="text-danger m-0 pmisdanger" style="font-size: x-large;">
                        Jumlah Isian Buku Tamu Simfast Jateng
                    </h1>
                    <span><i class="fas fa-user-plus"></i> Hari ini: {{ G_numFormat(harini) }}</span><br>
                    <span><i class="fas fa-user-check"></i> Bulan ini: {{ G_numFormat(bulanini) }}</span><br>
                    <span><i class="fas fa-user-tie"></i> Tahun ini: {{ G_numFormat(tahunini) }}</span><br>
                    <span><i class="fas fa-user-circle"></i> Total isian buku tamu: {{ G_numFormat(totalpengunjung)
                    }}</span>
                    <div class="lockscreen-item wow fadeInLeft" style="background: transparent;">
                        <button class="btn btn-danger2 btn-block text-white" data-toggle="tooltip" data-placement="left"
                            title="Lihat Detail Buku Tamun.." style="color: black;" v-on:click="loginAct">
                            <b><i class="fas fa-user-friends"></i>
                                Lihat Detail Buku Tamu
                            </b>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="container-fluid py-2">
        <div class="section-title py-2">
            <div class="row">
                <div class="col-sm-12 wow fadeInRight" data-wow-delay="0.3s">
                    <div class="rounded h-100">
                        <iframe class="rounded w-100" style="height: 500px;" :src="sourcenya" loading="lazy"
                            referrerpolicy="no-referrer-when-downgrade" @load="loadkontak()"></iframe>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- Contact End -->
    <a href="#" class="btn btn-dangerbulet btn-lg-square back-to-top text-white"><i class="fa fa-arrow-up"></i></a>
    <Footer />
</template>

<script>
import axios from 'axios';
import $ from 'jquery';
import swal from 'sweetalert2';

import Top from "./Template/Top.vue";
import Footer from "./Template/Footer.vue";

export default {
    components: {
        Top, Footer, swal
    },
    data() {
        return {
            halamanloading: true,
            tahun: new Date().getFullYear(),
            bahasa: localStorage.getItem("bahasasistem"),
            sourcenya: '',
            harini: 0,
            bulanini: 0,
            tahunini: 0,
            totalpengunjung: 0,
            ipnya: '',
            datapesan: '',
            datanya: [],
            carikata: '',
            jumlahdata: 0,
            jumlahhalaman: 0,
            mulai: 0,
            halaman: 1,
            tampilmodal: localStorage.getItem("bookstamu"),
        };
    },
    methods: {
        onlyNumberKey(evt) {
            // Only ASCII character in that range allowed
            evt = (evt) ? evt : window.event;
            var charCode = (evt.which) ? evt.which : evt.keyCode;
            if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
                evt.preventDefault();;
            } else {
                return true;
            } return;
        },
        rubahisi() {
            if ((this.showHuman == false) && (this.capcha == this.capchainput.toUpperCase())) {
                if (this.nama.length <= 2) {
                    this.showHuman = false;
                    document.getElementById("customSwitchAuth").checked = false;
                    swal.mixin({
                        toast: true,
                        position: 'top-end',
                        showConfirmButton: false,
                        timer: 3000
                    }).fire({
                        icon: 'warning',
                        title: 'Isikan nama dengan benar',
                    });
                    return false;
                }
                if ((this.hp.length <= 4) || (typeof parseInt(this.hp) != "number")) {
                    document.getElementById("customSwitchAuth").checked = false;
                    this.showHuman = false;
                    swal.mixin({
                        toast: true,
                        position: 'top-end',
                        showConfirmButton: false,
                        timer: 3000
                    }).fire({
                        icon: 'warning',
                        title: 'Isikan nomor telp dengan benar',
                    });
                    return false;
                }
                if (this.keperluan.length <= 3) {
                    document.getElementById("customSwitchAuth").checked = false;
                    this.showHuman = false;
                    swal.mixin({
                        toast: true,
                        position: 'top-end',
                        showConfirmButton: false,
                        timer: 3000
                    }).fire({
                        icon: 'warning',
                        title: 'Isikan keperluan dengan benar',
                    });
                    return false;
                }
                this.showHuman = true;
            }
            else {
                if (this.capcha != this.capchainput.toUpperCase()) {
                    document.getElementById("customSwitchAuth").checked = false;
                    this.showHuman = false;
                    swal.mixin({
                        toast: true,
                        position: 'top-end',
                        showConfirmButton: false,
                        timer: 3000
                    }).fire({
                        icon: 'warning',
                        title: 'Kode keamanan tidak sama',
                    });
                }
                this.showHuman = false;
            }
        },
        loadkontak() {
            this.halamanloading = true;
            const message = this.linknya;
            const iframe = document.querySelector("iframe");
            this.sourcenya = '';
            this.sourcenya = 'https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d15841.00777220044!2d110.4139116!3d-6.9795703!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x7dbe92a671168bcd!2sBAPPEDA+Provinsi+Jawa+Tengah!5e0!3m2!1sid!2sid!4v1555622193909!5m2!1sid!2sid';
            iframe.contentWindow.postMessage(message, "*");
            this.halamanloading = false;
        },
        tutupmodal() {
            $('#costumModaldisclaimerbukutamu').modal('hide');
        },
        async loginAct() {
            const mainAPI = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer GPMop8LQ06S0rZXcJyEH3wk8jVrINbHwn7tBq2",
                },
            });
            var random = Math.random();

            await mainAPI.get("parastapainnovationip-Key?random=" + random).then(
                Response => {
                    this.datapesan = Response.data.message;
                    if (this.datapesan == 'data diketemukan') {
                        this.ipnya = Response.data.randkey;
                    }
                    else {
                        this.ipnya = '';
                    }
                    this.halamanloading = false;
                }
            ).catch(error => {
                this.datapesan = [];
                console.log(error);
            });

            const mainAPINew = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer GPMop8LQ06S0rZXcJyEH3wk8jVrINbHwn7tBq2" + this.ipnya,
                },
            });

            await mainAPINew.get("parastapainnovatioBukuTamu-GetDetailData?random=" + random).then(
                Response => {
                    this.datanya = [];
                    this.datapesan = Response.data.message;
                    if (this.datapesan == 'data diketemukan') {
                        this.datanya = Response.data.content.data;
                        this.jumlahdata = Response.data.content.jumlahdata;
                        this.jumlahhalaman = Response.data.content.jumlahhalaman;
                        this.mulai = Response.data.content.mulai;
                        if (this.mulai == 0) {
                            this.halaman = 1;
                        }
                        else {
                            this.halaman = (this.mulai / 20) + 1;
                        }
                        $('#costumModaldisclaimerbukutamu').modal('show');
                    }
                    else {
                        this.datapesan = "";
                        this.datanya = [];
                        this.jumlahdata = 0;
                        this.jumlahhalaman = 0;
                        this.mulai = 0;
                    }
                    this.halamanloading = false;
                }
            ).catch(error => {
                console.log(error);
            });
        },
        onChangeHalaman(event) {
            this.pindahhalaman(event.target.value);
        },
        async pindahhalaman(halamannya) {
            this.halamanloading = true;

            const mainAPI = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer GPMop8LQ06S0rZXcJyEH3wk8jVrINbHwn7tBq2",
                },
            });
            var random = Math.random();

            await mainAPI.get("parastapainnovationip-Key?random=" + random).then(
                Response => {
                    this.datapesan = Response.data.message;
                    if (this.datapesan == 'data diketemukan') {
                        this.ipnya = Response.data.randkey;
                    }
                    else {
                        this.ipnya = '';
                    }
                    this.halamanloading = false;
                }
            ).catch(error => {
                this.datapesan = "";
                console.log(error);
            });

            const mainAPINew = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer GPMop8LQ06S0rZXcJyEH3wk8jVrINbHwn7tBq2" + this.ipnya,
                },
            });

            await mainAPINew.get("parastapainnovatioBukuTamu-GetDetailData?random=" + random + "&halaman=" + halamannya).then(
                Response => {
                    this.datanya = [];
                    this.datapesan = Response.data.message;
                    if (this.datapesan == 'data diketemukan') {
                        this.datanya = Response.data.content.data;
                        this.jumlahdata = Response.data.content.jumlahdata;
                        this.jumlahhalaman = Response.data.content.jumlahhalaman;
                        this.mulai = Response.data.content.mulai;
                        if (this.mulai == 0) {
                            this.halaman = 1;
                        }
                        else {
                            this.halaman = (this.mulai / 20) + 1;
                        }
                    }
                    else {
                        this.datanya = [];
                    }
                    this.halamanloading = false;
                }
            ).catch(error => {
                this.datapesan = "";
                console.log(error);
            });
        },
        async ambildata() {
            const mainAPI = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer GPMop8LQ06S0rZXcJyEH3wk8jVrINbHwn7tBq2",
                },
            });
            var random = Math.random();

            await mainAPI.get("parastapainnovationip-Key?random=" + random).then(
                Response => {
                    this.datapesan = Response.data.message;
                    if (this.datapesan == 'data diketemukan') {
                        this.ipnya = Response.data.randkey;
                    }
                    else {
                        this.ipnya = '';
                    }
                    this.halamanloading = false;
                }
            ).catch(error => {
                this.datapesan = [];
                console.log(error);
            });

            const mainAPINew = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer GPMop8LQ06S0rZXcJyEH3wk8jVrINbHwn7tBq2" + this.ipnya,
                },
            });

            await mainAPINew.get("parastapainnovatioBukuTamu-GetTamu?random=" + random).then(
                Response => {
                    this.datapesan = Response.data.message;
                    if (this.datapesan == 'data diketemukan') {
                        this.harini = Response.data.hariini;
                        this.bulanini = Response.data.bulanini;
                        this.tahunini = Response.data.tahunini;
                        this.totalpengunjung = Response.data.total;
                    }
                    else {
                        swal.fire({
                            title: "Informasi",
                            text: "Peringatan interupsi data!",
                            icon: "error"
                        }).then(function () {

                        });
                        $('.swal2-container').css("z-index", '999999');
                    }
                    this.halamanloading = false;
                }
            ).catch(error => {
                this.datapesan = [];
                console.log(error);
                swal.fire({
                    title: "Informasi",
                    text: "Peringatan interupsi data!",
                    icon: "error"
                }).then(function () {

                });
                $('.swal2-container').css("z-index", '999999');
            });

            if ((this.tampilmodal == null) || (this.tampilmodal == '') || (this.tampilmodal == undefined)) {
                $('#costumModaldisclaimer').modal('show');
            }

            var time = Date.parse(localStorage.getItem("bookstamu"));
            var timeakhir = time + (1 * 60 * 60 * 1000);
            var timesekarang = Date.parse(new Date());
            if (timesekarang > timeakhir) {
                $('#costumModaldisclaimer').modal('show');
            }
        },
        async setuju() {
            this.halamanloading = true;

            const mainAPI = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer GPMop8LQ06S0rZXcJyEH3wk8jVrINbHwn7tBq2",
                },
            });
            var random = Math.random();

            await mainAPI.get("parastapainnovationip-Key?random=" + random).then(
                Response => {
                    this.datapesan = Response.data.message;
                    if (this.datapesan == 'data diketemukan') {
                        this.ipnya = Response.data.randkey;
                    }
                    else {
                        this.ipnya = '';
                    }
                    this.halamanloading = false;
                }
            ).catch(error => {
                this.datapesan = [];
                console.log(error);
            });

            this.halamanloading = true;
            const data = {
                tamuparastapa: 'tamuparastapa',
                nama: this.nama,
                hp: this.hp,
                keperluan: this.keperluan,
            };
            const mainAPIVisitor = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer GPMop8LQ06S0rZXcJyEH3wk8jVrINbHwn7tBq2" + this.ipnya,
                    "Content-Type": "application/x-www-form-urlencoded",
                },
            });
            await mainAPIVisitor.post("parastapainnovatioBukuTamu-IsiTamu", data).then(
                Response => {
                    if (Response.data.response == 'error') {
                        swal.mixin({
                            toast: true,
                            position: 'top-end',
                            showConfirmButton: false,
                            timer: 3000
                        }).fire({
                            icon: 'warning',
                            title: Response.data.message,
                        });
                        this.halamanloading = false;
                        return false;
                    }
                    else {
                        localStorage.setItem("bookstamu", new Date().toString());
                        $('#costumModaldisclaimer').modal('hide');
                        this.halamanloading = false;
                        //window.location.reload();
                    }
                }
            ).catch(
                error => {
                    swal.mixin({
                        toast: true,
                        position: 'top-end',
                        showConfirmButton: false,
                        timer: 3000
                    }).fire({
                        icon: 'warning',
                        title: error,
                    });
                }
            )

        },
    },
    mounted() {
        this.halamanloading = true;
        this.ambildata();
        window.addEventListener('keydown', function (event) {
            if (event.code == 'KeyZ' && (event.ctrlKey || event.metaKey)) {
                localStorage.setItem("bookstamu", new Date().toString());
                $('#costumModaldisclaimer').modal('hide');
            }
        });
    },
}
</script>

<style></style>